module.exports = __webpack_public_path__ + "media/images/online_talks/TIMS-fb7648f8383c5b9716b4516f341d2bca.png";